"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThreadCreatePayloadSchema = exports.ThreadListSchema = exports.ThreadObjectSchema = void 0;
const zod_1 = require("zod");
const list_1 = require("../list");
const workflow_1 = require("../workflow");
exports.ThreadObjectSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    object: zod_1.z.literal('thread'),
    workflow: workflow_1.WorkflowTypeSchema,
    created_at: zod_1.z.date().openapi({ format: 'date-time' }),
})
    .openapi('ThreadObject');
exports.ThreadListSchema = (0, list_1.ListResponseSchema)(exports.ThreadObjectSchema, {
    title: 'ThreadList',
});
exports.ThreadCreatePayloadSchema = zod_1.z
    .discriminatedUnion('type', [
    zod_1.z
        .object({
        type: zod_1.z.literal('survey'),
        data: workflow_1.WorkflowSurveyInputSchema,
    })
        .openapi('ThreadCreateSurveyPayload'),
    zod_1.z
        .object({
        type: zod_1.z.literal('analysis'),
        data: workflow_1.WorkflowSurveyInputSchema,
    })
        .openapi('ThreadCreateAnalysisPayload'),
    zod_1.z
        .object({
        type: zod_1.z.literal('interview'),
        data: workflow_1.WorkflowInterviewInputSchema,
    })
        .openapi('ThreadCreateInterviewPayload'),
])
    .openapi('ThreadCreatePayload');
//# sourceMappingURL=threadSchema.js.map